export default __webpack_public_path__ + "static/media/naba.929f28d1.jpg";